import type { StoryData } from "storyblok-js-client";
import { getLocaleByLanguage } from "utils/getLocaleByLanguage";
import type { LanguageCode } from "config/languages";
import { defaultDateFormatOptions } from "./consts";
import { addTimeSeparatorToDate } from "./addTimeSeparatorToDate";

export const getStoryLastUpdatedDate = (story: StoryData, currentLanguage: LanguageCode) => {
  const {
    published_at: publishedAt,
    created_at: createdAt,
    content: { updatedAt },
  } = story;

  const updatedAtWithTimeSeparator = addTimeSeparatorToDate(updatedAt);
  const storyRawDate = updatedAtWithTimeSeparator || publishedAt || createdAt;
  if (!storyRawDate) return "";

  const date = new Date(storyRawDate);
  const locale = getLocaleByLanguage(currentLanguage);

  return new Intl.DateTimeFormat(locale, defaultDateFormatOptions).format(date);
};
